import { useLocation } from "react-router-dom";
import React, { useState } from "react";
import FormEpisode from "./FormEpisode";
import { putEpisode } from "../../api/Put";
import { message } from "antd";

const PutEpisode = () => {
  const { state } = useLocation();
  const { episode } = state;

  const [messageApi, contextHolder] = message.useMessage();

  const [errorMsg, setErrorMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const success = () => {
    messageApi.open({
      type: "success",
      content: "Épisode mis à jour",
    });
  };

  const onFinish = async (values) => {
    setIsLoading(true);
    setErrorMsg("");
    const { author, epCover, illustrator, epName, epNumber, epState, saison } =
      values;

    const formData = new FormData();
    if (epCover) formData.append("fileToUpload", epCover.file);
    formData.append("author", author);
    formData.append("illustrator", illustrator);
    formData.append("epName", epName);
    formData.append("epState", epState);
    formData.append("epId", episode.id);

    const res = await putEpisode(formData, saison, epNumber);
    if (res.error) setErrorMsg(res.error);
    else success();
    setIsLoading(false);
  };

  return (
    <>
      {contextHolder}
      <FormEpisode
        title={`Mettre à jour`}
        onFinish={onFinish}
        initialValues={{
          saison: episode.SeasonId,
          epState: episode.statut,
          epNumber: episode.number,
          illustrator: episode.illustrator,
          author: episode.author,
          epName: episode.name,
        }}
        errorMsg={errorMsg}
        isLoading={isLoading}
      />
    </>
  );
};

export { PutEpisode };
